// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"638":"ef686424","775":"02bcd08e"}[chunkId] + ".css";
};